import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/DonationCard/DonationCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/DonationCard/NepalFloodCampaignPage.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/new/DonationCard/DonationPage.module.css");
